module.exports = __webpack_public_path__ + "img/logo-white.fb141b15.svg";